export default __webpack_public_path__ + "1f924bbfed989cd8b09e5a2dc9a63a01.png";